let loadedConfig: Config | undefined = undefined;

const getConfig = async (): Promise<Config> => {
  if (loadedConfig) return loadedConfig;

  const response = await fetch('/server/env');
  const body = await response.json();
  if (response.status !== 200) {
    throw Error(body.message);
  }
  const config: Config = { ...body, apiUrl: '/server/api', defaultPollInterval: 5 * 60 * 1000 };
  loadedConfig = config;
  return config;
};

export default getConfig;

export function useConfig(): Config | undefined {
  return loadedConfig;
}

export interface Config {
  authorityUrl: string;
  idp: string;
  apiUrl: string;
  portalUrl: string;
  env: string;
  defaultPollInterval: number;
  unleashUrl: string;
  unleashAccessToken: string;
  tiptapCloudAppId: string;
  statisticsApiUrl: string;
}
